import { render } from "./AdminHeader.vue?vue&type=template&id=26c1b89f"
import script from "./AdminHeader.vue?vue&type=script&lang=js"
export * from "./AdminHeader.vue?vue&type=script&lang=js"
script.render = render

export default script